import Ueditor from './Ueditor'
export default Ueditor
